import { Heading } from "../../elements";
import { TTableProps, Table } from "../../elements/table/table";

type TTableBlockProps = {
  title?: string;
  text?: React.ReactNode;
  table: TTableProps;
  postTableText?: React.ReactNode;
};

type TInternalProps = { isBlock: boolean } & TTableBlockProps;

const TableInner = ({ isBlock, title, text, table, postTableText }: TInternalProps) => {
  return (
    <div>
      {title && (
        <Heading semanticType={isBlock ? "h2" : "h3"} visualType={isBlock ? "h3" : "h4"}>
          {title}
        </Heading>
      )}
      {text && text}
      <Table {...table} />
      {postTableText && <div className={"body-s"}>{postTableText}</div>}
    </div>
  );
};

const TableBlockContent = (props: TTableBlockProps) => {
  return (
    <div className={"space-mb-lg"}>
      <TableInner {...props} isBlock={false} />
    </div>
  );
};

export { TableBlockContent };
